import {
  UPDATE_VALUE,
} from 'containers/Form/Slider/constants'

const RUN_RISK_VALIDATION = 'fulcrum/container/Form/RiskSlider/RUN_RISK_VALIDATION'

export {
  UPDATE_VALUE,
  RUN_RISK_VALIDATION
}
